export enum Envinronments {
  Development = "development",
  Staging = "staging",
  Production = "production",
}
